// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ResponseRolloutReasonType = {
  RolloutReasonTypeRolloutPausing: 'RolloutPausing',
  RolloutReasonTypeRolloutPaused: 'RolloutPaused',
  RolloutReasonTypeRolloutNotPaused: 'RolloutNotPaused',
  RolloutReasonTypeTransferring: 'Transferring',
  RolloutReasonTypeTransferred: 'Transferred',
  RolloutReasonTypeRolloutAborted: 'RolloutAborted',
  RolloutReasonTypeRolloutLive: 'RolloutLive',
  RolloutReasonTypeRolloutCompleted: 'RolloutCompleted',
  RolloutReasonTypeDeploymentReady: 'DeploymentReady',
  RolloutReasonTypeDeploymentNotReady: 'DeploymentNotReady',
  RolloutReasonTypeInProgress: 'InProgress',
  RolloutReasonTypeOwnsResources: 'OwnsResources',
  RolloutReasonTypeStable: 'Stable',
  RolloutReasonTypeNoResources: 'NoResources',
  RolloutReasonTypeNoApprovalRequired: 'NoApprovalRequired',
  RolloutReasonTypeApproved: 'Approved',
  RolloutReasonTypeWaitingForApproval: 'WaitingForApproval',
  RolloutReasonTypeNoCooldown: 'NoCooldown',
  RolloutReasonTypeCooldownSkipped: 'CooldownSkipped',
  RolloutReasonTypeCooldownElapsed: 'CooldownElapsed',
  RolloutReasonTypeCoolingDown: 'CoolingDown',
} as const;
export type ResponseRolloutReasonType =
  (typeof ResponseRolloutReasonType)[keyof typeof ResponseRolloutReasonType];

export function instanceOfResponseRolloutReasonType(value: any): boolean {
  for (const key in ResponseRolloutReasonType) {
    if (Object.prototype.hasOwnProperty.call(ResponseRolloutReasonType, key)) {
      if (
        ResponseRolloutReasonType[
          key as keyof typeof ResponseRolloutReasonType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ResponseRolloutReasonTypeFromJSON(
  json: any,
): ResponseRolloutReasonType {
  return ResponseRolloutReasonTypeFromJSONTyped(json, false);
}

export function ResponseRolloutReasonTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutReasonType {
  return json as ResponseRolloutReasonType;
}

export function ResponseRolloutReasonTypeToJSON(
  value?: ResponseRolloutReasonType | null,
): any {
  return value as any;
}

export function ResponseRolloutReasonTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutReasonType {
  return value as ResponseRolloutReasonType;
}
